export default __webpack_public_path__ + "953d59469b3e0454e58e8237bb945d8f.webp";